import axios from "axios";
import { ReactSession } from "react-client-session";
const URL = process.env.REACT_APP_URL;

const useRefreshToken = () => {
  const refreshToken = ReactSession.get("refreshToken");

  const refershToken = async () => {
    const response = await axios.post(
      
      `${URL}/auth/token/refresh/`,
      {
        refresh: refreshToken,
      }
    );
    ReactSession.set("accessToken", response.data.access);

    return await response.data.access;
  };

  return refershToken;
};

export default useRefreshToken;
